<template>
  <section class="tw-py-2">
    <div class="tw-w-full">
      <div class="tw-grid tw-grid-cols-12 tw-gap-1">
        <div class="tw-col-span-12 md:tw-col-span-6">
          <!-- TODO: extract data table search to separate component -->
          <!-- https://gitlab.titanhq.com/titanhq/dev/fe/thq-fe-component/-/issues/28 -->
          <template v-if="props.withSearch">
            <div class="tw-w-full">
              <label for="cl-data-table-search" class="tw-sr-only"
                >Search</label
              >
              <div class="tw-relative md:tw-max-w-xs">
                <input
                  id="cl-data-table-search"
                  v-model="search"
                  class="tw-block tw-w-full tw-rounded tw-border tw-border-solid tw-border-primary-grey-100/80 tw-bg-white tw-py-2 tw-pl-9 tw-pr-2 tw-text-base tw-text-primary-grey-700 tw-outline-none tw-transition-all focus:tw-border-primary-grey-500 focus:tw-ring-4 focus:tw-ring-primary-grey-500/10"
                  :class="[isSomeItemsSelected ? 'tw-w-1/2' : 'tw-w-full']"
                  type="search"
                  :data-test-id="`${props.testId}-search`"
                  :placeholder="props.searchPlaceholder"
                  @input="emitSearch($event)"
                />
                <div
                  class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3"
                >
                  <ClIconTablerSearch
                    width="20px"
                    height="20px"
                    class="tw-text-primary-grey-200"
                  />
                </div>
              </div>
            </div>
          </template>
          <slot name="search" />
        </div>
        <div class="tw-col-span-12 md:tw-col-span-6">
          <div class="tw-flex tw-w-full tw-items-center tw-justify-end">
            <div v-if="isSomeItemsSelected" class="tw-flex tw-items-center">
              <template v-if="selectedItems">
                <div class="tw-relative">
                  <span
                    class="tw-whitespace-nowrap tw-pr-2 tw-text-sm tw-text-primary-grey-700"
                    >{{ selectedItems.length }} Selected</span
                  >
                </div>
              </template>
              <template v-if="props.withDelete">
                <div class="tw-relative">
                  <button
                    class="tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-system-error-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-system-error-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-system-error-600 focus:tw-outline-4 focus:tw-outline-system-error-500/10 active:tw-border-system-error-800 active:tw-text-system-error-800"
                    type="button"
                    :data-test-id="`${props.testId}-delete`"
                    @click="emitDeleteItems"
                  >
                    {{ props.deletePlaceholder }}
                  </button>
                </div>
              </template>
              <template v-if="props.withRelease">
                <div class="tw-relative">
                  <button
                    class="tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-primary-grey-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-primary-grey-700 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-primary-grey-600 focus:tw-outline-4 focus:tw-outline-primary-grey-500/10 active:tw-border-primary-grey-800 active:tw-text-primary-grey-800"
                    type="button"
                    :data-test-id="`${props.testId}-release`"
                    @click="emitReleaseItems"
                  >
                    {{ props.releasePlaceholder }}
                  </button>
                </div>
              </template>
              <template v-if="props.withAllow">
                <div class="tw-relative">
                  <button
                    class="tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-primary-grey-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-primary-grey-700 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-primary-grey-600 focus:tw-outline-4 focus:tw-outline-primary-grey-500/10 active:tw-border-primary-grey-800 active:tw-text-primary-grey-800"
                    type="button"
                    :data-test-id="`${props.testId}-allow`"
                    @click="emitAllowItems"
                  >
                    {{ props.allowPlaceholder }}
                  </button>
                </div>
              </template>
            </div>
            <template v-if="slots['actions']">
              <slot name="actions" :selected-items="selectedItems"></slot>
            </template>
            <template v-if="withSetColumns">
              <div ref="columnSetTooltip" class="column-set-tooltip-wrapper">
                <button
                  class="tw-group tw-mx-4 tw-flex tw-h-9 tw-items-center tw-justify-center tw-border-l-2 tw-border-solid tw-border-primary-grey-100 tw-pl-4"
                  @click="toggleSetColumnTooltip"
                >
                  <ClIconTablerTable
                    :width="'24'"
                    :height="'24'"
                    class="tw-transition-colors group-hover:tw-stroke-primary-grey-500"
                    :class="
                      isColumnSetTooltipOpen
                        ? 'tw-stroke-primary-grey-500'
                        : 'tw-stroke-primary-grey-500'
                    "
                  />
                </button>
                <div
                  v-if="isColumnSetTooltipOpen"
                  id="set-rows-wrapper"
                  class="tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-flex-col tw-rounded-md tw-border tw-border-primary-grey-100 tw-bg-white tw-p-2 tw-shadow-md tw-transition-opacity"
                >
                  <div
                    v-for="header in tableHeaderCells"
                    :key="header.key"
                    class="tw-my-1"
                  >
                    <label
                      :for="header.key"
                      class="tw-ml-2 tw-flex tw-items-center"
                    >
                      <input
                        :id="header.key"
                        v-model="tableCellsToDisplay"
                        :value="header.key"
                        type="checkbox"
                        class="tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-primary-grey-500 tw-bg-white tw-text-primary-grey-700 checked:tw-border-primary-grey-500 focus:tw-ring-primary-grey-500 focus:tw-ring-offset-white disabled:tw-border-primary-grey-100 disabled:tw-text-primary-grey-100 disabled:checked:tw-border-primary-grey-100 dark:tw-border-primary-grey-400"
                        :disabled="
                          tableCellsToDisplay.length <= 1 && header.enabled
                        "
                      />
                      <span
                        class="text-dorian-gray-300 tw-ml-3 tw-text-base"
                        :class="
                          tableCellsToDisplay.length <= 1 &&
                          header.enabled &&
                          'tw-text-primary-grey-200'
                        "
                      >
                        {{ header.label }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- DataTable -->
  <section class="tw-mb-6tw-p-2">
    <div ref="scrollContainer" class="tw-overflow-x-auto">
      <table
        class="tw-w-full tw-rounded tw-text-left tw-text-base dark:tw-border dark:tw-border-solid dark:tw-border-primary-grey-100/80"
      >
        <thead class="tw-bg-white">
          <tr>
            <th v-if="props.withSelect" scope="col" class="tw-pl-4">
              <div class="tw-flex tw-items-center">
                <input
                  :id="'table-header-select-all'"
                  v-model="selectAll"
                  :disabled="!props.withSelectAll"
                  type="checkbox"
                  :class="{
                    'tw-h-4 tw-w-4 tw-rounded tw-border-2 tw-border-solid tw-border-primary-grey-100 tw-bg-primary-grey-100 hover:tw-cursor-not-allowed dark:tw-border-primary-grey-50':
                      !props.withSelectAll,
                    'tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-primary-grey-500 tw-bg-white tw-text-primary-grey-700 checked:tw-border-primary-grey-500 focus:tw-ring-primary-grey-500 focus:tw-ring-offset-white disabled:tw-border-primary-grey-100 disabled:tw-text-primary-grey-100 disabled:checked:tw-border-primary-grey-100 dark:tw-border-primary-grey-400':
                      props.withSelectAll,
                  }"
                  @change="onSelectAll"
                />
                <label for="table-header-select-all" class="tw-sr-only"
                  >checkbox</label
                >
              </div>
            </th>
            <template v-for="header in tableHeaderCells" :key="header.label">
              <th
                v-if="header.enabled"
                scope="col"
                :class="tableHeaderCellClass(header)"
              >
                <div
                  class="tw-inline-flex tw-items-center tw-py-1"
                  :class="tableHeaderCellContentClass(header)"
                >
                  <div
                    class="tw-peer"
                    :class="
                      header.sortable
                        ? 'hover:tw-cursor-pointer'
                        : 'tw-cursor-auto'
                    "
                    @click="handleSort(header)"
                  >
                    <slot
                      :name="`header.cell.${String(
                        header.label,
                      ).toLocaleLowerCase()}`"
                      :text="header.label"
                    >
                      <span
                        class="tw-whitespace-nowrap tw-font-bold"
                        :data-test-id="`${props.testId}-checkbox-selected-${header.key}`"
                        >{{ header.label }}</span
                      >
                    </slot>
                  </div>
                  <ClTooltip
                    v-if="header.tooltip"
                    :id="header.key"
                    :text="header.tooltip"
                    class="tw-ml-1 hover:tw-cursor-pointer"
                  >
                    <span v-if="header.tooltip">
                      <ClIconTablerInfoCircle :width="16" :height="16" />
                    </span>
                  </ClTooltip>
                  <span
                    :class="
                      header.sortable && sortBy === header.key
                        ? 'peer-hover:tw-visible'
                        : 'tw-invisible'
                    "
                  >
                    <ClIconTablerArrowDown
                      v-if="sortDesc === 'desc'"
                      :width="'16'"
                      :height="'16'"
                    />
                    <ClIconTablerArrowUp v-else :width="'16'" :height="'16'" />
                  </span>
                </div>
              </th>
            </template>
          </tr>
        </thead>
        <tbody v-if="props.fetching">
          <tr
            v-for="item in skeletonArray"
            :key="item.id"
            class="tw-border-b tw-border-primary-grey-100/80 tw-bg-white"
          >
            <td v-if="props.withSelect" class="tw-w-4 tw-px-4">
              <div
                class="tw-w-30 tw-h-5 tw-animate-pulse tw-bg-primary-grey-25"
              ></div>
            </td>
            <td
              v-for="key in tableBodyCells"
              :key="item[key]"
              class="h-2 bg-slate-200 rounded tw-animate-pulse tw-whitespace-nowrap tw-px-6"
            >
              <div
                class="tw-w-30 tw-h-5 tw-animate-pulse tw-bg-primary-grey-25"
              ></div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr
            v-if="itemsToDisplay.length === 0"
            class="tw-border-b tw-border-primary-grey-100/80 tw-bg-primary-grey-25"
          >
            <td colspan="100%" class="tw-text-center">
              <template v-if="slots['empty']">
                <slot name="empty" />
              </template>
              <div v-else>No data available</div>
            </td>
          </tr>
          <tr
            v-for="(trItem, index) in itemsToDisplay"
            :key="trItem.id"
            class="tw-border-b tw-border-primary-grey-100/80"
            :class="[
              isRowClicked === trItem.id && props.withRowClick
                ? 'tw-bg-primary-grey-200'
                : 'hover:tw-bg-primary-grey-25 dark:hover:tw-bg-primary-grey-100',
              props.zebra && index % 2 === 0 && isRowClicked !== trItem.id
                ? 'tw-bg-primary-grey-50'
                : '',
              props.zebra && index % 2 !== 0 && isRowClicked !== trItem.id
                ? 'tw-bg-white'
                : '',
            ]"
            @click="rowClick(trItem)"
          >
            <td v-if="props.withSelect" class="tw-w-4 tw-px-4" @click.stop>
              <div class="tw-flex tw-items-center">
                <input
                  :id="`select-${trItem.id}`"
                  v-model="selectedItems"
                  :data-test-id="`${props.testId}-checkbox-selected-${trItem.id}`"
                  :value="trItem"
                  type="checkbox"
                  :class="{
                    'tw-h-4 tw-w-4 tw-rounded tw-border-2 tw-border-solid tw-border-primary-grey-100 tw-bg-primary-grey-100 hover:tw-cursor-not-allowed dark:tw-border-primary-grey-50':
                      trItem.metadata?.inherited,
                    'tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-primary-grey-500 tw-bg-white tw-text-primary-grey-700 checked:tw-border-primary-grey-500 focus:tw-ring-primary-grey-500 focus:tw-ring-offset-white disabled:tw-border-primary-grey-100 disabled:tw-text-primary-grey-100 disabled:checked:tw-border-primary-grey-100 dark:tw-border-primary-grey-400':
                      !trItem.metadata?.inherited,
                  }"
                  :disabled="trItem.metadata?.inherited"
                  @change="onSingleSelect"
                />
                <label :for="`select-${trItem.id}`" class="tw-sr-only"
                  >checkbox</label
                >
              </div>
            </td>
            <td
              v-for="key in tableBodyCells"
              :key="trItem[key]"
              class="tw-relative tw-align-middle"
              :class="tableBodyCellClass(key)"
            >
              <div
                class="tw-flex tw-whitespace-nowrap tw-py-1"
                :class="tableBodyCellContentClass(key)"
                @click="scrollToBottom"
              >
                <template v-if="['twofa_enforce', 'locked'].includes(key)">
                  <span
                    class="tw-rounded tw-px-2 tw-py-1 tw-font-semibold"
                    :class="
                      trItem[key] === 'On'
                        ? 'tw-text-primary-grey-700'
                        : 'tw-text-system-error-500 '
                    "
                  >
                    {{ trItem[key] }}
                  </span>
                </template>
                <slot
                  v-else
                  :name="`body.cell.${String(key).toLocaleLowerCase()}`"
                  :td-value="trItem[key]"
                  :tr-item="trItem"
                >
                  {{ trItem[key] }}
                </slot>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
  <!-- Pagination -->
  <section class="tw-mb-6 tw-p-2">
    <div class="tw-w-full">
      <slot name="pagination">
        <div class="tw-grid tw-grid-cols-12 tw-gap-1">
          <div class="tw-col-span-12 md:tw-col-span-6">
            <div class="tw-relative">
              <div
                class="tw-mr-4 tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start"
              >
                <label
                  class="tw-mr-4 tw-whitespace-nowrap tw-text-sm tw-text-primary-grey-700"
                >
                  Rows per page:
                </label>
                <select
                  v-model="maxItemsOnPage"
                  name="rows-per-page"
                  class="tw-focus:border-gray-200 peer tw-block tw-w-full tw-appearance-none tw-border-0 tw-border-b-2 tw-border-solid tw-border-primary-grey-100/80 tw-bg-white tw-text-sm tw-text-primary-grey-700 tw-outline-none focus:tw-border-primary-grey-500 focus:tw-ring-0"
                  @change="changeItemsOnPage"
                >
                  <option
                    v-for="value in props.itemsPerPage"
                    :key="value"
                    :value="value"
                    :selected="value === maxItemsOnPage"
                  >
                    {{ value }}
                  </option>
                </select>
              </div>
              <div
                v-if="itemsToDisplay.length !== 0"
                class="tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start"
              >
                <span class="tw-text-sm tw-text-primary-grey-700"
                  >{{ indexPointer.start + 1 }}-{{
                    indexPointer.start + itemsToDisplay.length
                  }}
                  <span
                    >of
                    {{
                      props.withServerSidePagination
                        ? props.total
                        : tableItems.length
                    }}</span
                  >
                </span>
              </div>
            </div>
          </div>
          <div class="tw-col-span-12 md:tw-col-span-6">
            <div class="tw-relative tw-flex tw-justify-end">
              <button
                class="tw-bg-transparent tw-mr-[-1px] tw-rounded-l tw-border-2 tw-border-solid tw-border-primary-grey-500 tw-px-2 tw-text-sm tw-font-medium tw-text-primary-grey-200 hover:tw-text-primary-grey-700 disabled:tw-cursor-default disabled:tw-border-r disabled:tw-border-primary-grey-100/80 disabled:tw-text-primary-grey-200"
                :disabled="currentPage === STARTING_PAGE"
                @click="goPrev"
              >
                <span class="tw-sr-only">Previous</span>
                <ClIconTablerChevronLeft :width="'16'" :height="'16'" />
              </button>
              <button
                class="tw-bg-transparent tw-ml-[-1px] tw-rounded-r tw-border-2 tw-border-solid tw-border-primary-grey-500 tw-px-2 tw-text-sm tw-font-medium tw-text-primary-grey-200 hover:tw-text-primary-grey-700 disabled:tw-cursor-default disabled:tw-border-l disabled:tw-border-primary-grey-100/80 disabled:tw-text-primary-grey-200"
                :disabled="currentPage >= pagesCount"
                @click="goNext"
              >
                <span class="tw-sr-only">Next</span>
                <ClIconTablerChevronRight :width="'16'" :height="'16'" />
              </button>
            </div>
          </div>
        </div>
      </slot>
    </div>
  </section>
  <!-- Actions -->
</template>

<script lang="ts" setup>
import { ref, computed, useSlots, watch } from "vue";
import { onClickOutside } from "@vueuse/core";

import { ClTooltip } from "../tooltip";

import {
  ClIconTablerTable,
  ClIconTablerArrowDown,
  ClIconTablerArrowUp,
  ClIconTablerChevronLeft,
  ClIconTablerChevronRight,
  ClIconTablerInfoCircle,
  ClIconTablerSearch,
} from "../icons";

import type { Ref } from "vue";
import type {
  DataTableItem,
  DataTableSortOrder,
  DataTableHeader,
} from "./types";

export interface DataTableProps {
  headers: DataTableHeader[];
  items: DataTableItem[];
  total: number;
  itemsPerPage?: number[];
  testId?: string;
  fetching?: boolean;
  withSelect?: boolean;
  withSelectAll?: boolean;
  withSearch?: boolean;
  withDelete?: boolean;
  withRelease?: boolean;
  withAllow?: boolean;
  withServerSidePagination?: boolean;
  deletePlaceholder?: string;
  releasePlaceholder?: string;
  allowPlaceholder?: string;
  searchPlaceholder?: string;
  searchBy?: string;
  withSetColumns?: boolean;
  zebra?: boolean;
  defaultItemsOnPage?: number;
  defaultSortBy?: string;
  defaultSortDesc?: DataTableSortOrder;
  withRowClick?: boolean;
  px?: number;
}

defineSlots();
const slots = useSlots();
const props = withDefaults(defineProps<DataTableProps>(), {
  itemsPerPage: () => [10, 25, 50],
  testId: "default-test-id",
  fetching: false,
  withSelect: false,
  withSelectAll: true,
  withSearch: false,
  withDelete: false,
  withRelease: false,
  withAllow: false,
  withSetColumns: false,
  withServerSidePagination: false,
  searchPlaceholder: "Search",
  deletePlaceholder: "Delete",
  releasePlaceholder: "Release",
  allowPlaceholder: "Allow",
  searchBy: "id",
  zebra: true,
  defaultItemsOnPage: 10,
  defaultSortBy: "",
  defaultSortDesc: "desc",
  withRowClick: false,
  px: 6,
});

const emit = defineEmits<{
  (event: "onDeleteItems", ids: DataTableItem[]): void;
  (event: "onReleaseItems", ids: DataTableItem[]): void;
  (event: "onAllowItems", ids: DataTableItem[]): void;
  (event: "search", phrase: string): void;
  (event: "sortItems", sortBy: string, sortDir: DataTableSortOrder): void;
  (event: "changePage", page: number): void;
  (event: "changeItemsOnPage", itemsOnPage: number): void;
  (event: "changeSelectedColumns", columns: string[]): void;
  (event: "onSelectItems", items: DataTableItem[]): void;
  (event: "onRowClick", item: DataTableItem): void;
}>();

const STARTING_PAGE = 1;

const isColumnSetTooltipOpen: Ref<boolean> = ref(false);
const search = ref("");
const maxItemsOnPage = ref(props.defaultItemsOnPage || props.itemsPerPage[0]);
const sortBy = ref(props.defaultSortBy);
const sortDesc: Ref<DataTableSortOrder> = ref(props.defaultSortDesc);
const selectAll = ref(false);
const selectedItems: Ref<DataTableItem[]> = ref([]);
const currentPage = ref(STARTING_PAGE);
const scrollContainer: Ref<HTMLElement | null> = ref(null);

const columnSetTooltip = ref(null);

const scrollToBottom = () => {
  if (scrollContainer.value) {
    scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight;
  }
};

const tableHeaderCells = ref(
  props.headers.map((header) => {
    const cell = { ...header };
    const isEnabledInObject = "enabled" in cell;

    if (!isEnabledInObject) {
      cell.enabled = true;
    }

    return cell;
  }),
);

const tableBodyCells = ref(
  tableHeaderCells.value.filter((cell) => cell.enabled).map((cell) => cell.key),
);

const tableCellsToDisplay = ref(
  tableHeaderCells.value.filter((cell) => cell.enabled).map((cell) => cell.key),
);

const indexPointer = computed(() => {
  const end = currentPage.value * maxItemsOnPage.value;
  const start = end - maxItemsOnPage.value;

  return { start, end };
});

const tableItems = computed(() => {
  if (props.withServerSidePagination) {
    return props.items;
  }

  const items = [...props.items];

  // Apply sort
  if (sortBy.value) {
    items.sort((a, b) => {
      const aValue = a[sortBy.value];
      const bValue = b[sortBy.value];

      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortDesc.value === "asc" ? aValue - bValue : bValue - aValue;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        const aDate = Date.parse(aValue);
        const bDate = Date.parse(bValue);

        if (!isNaN(aDate)) {
          return sortDesc.value === "asc" ? aDate - bDate : bDate - aDate;
        }

        return sortDesc.value === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return sortDesc.value === "asc" ? aValue - bValue : bValue - aValue;
    });
  }

  // Apply search
  if (props.withSearch && search.value) {
    return items.filter((item) =>
      item[props.searchBy].toLowerCase().includes(search.value.toLowerCase()),
    );
  }

  return items;
});

const itemsToDisplay = computed(() => {
  if (props.withServerSidePagination) {
    return props.items;
  }

  return tableItems.value.slice(
    indexPointer.value.start,
    indexPointer.value.end,
  );
});

const pagesCount = computed(() => {
  if (search.value.length !== 0 && !props.withServerSidePagination) {
    return Math.ceil(tableItems.value.length / maxItemsOnPage.value);
  }

  return Math.ceil(props.total / maxItemsOnPage.value);
});

const isSomeItemsSelected = computed(() => selectedItems.value.length > 0);

const tableHeaderCellClass = (header: DataTableHeader): string => {
  const stickyClass = header?.sticky ? "tw-sticky tw-right-0 tw-bg-white" : "";

  return stickyClass;
};

const tableHeaderCellContentClass = (header: DataTableHeader): string => {
  let stickyClass = header?.sticky
    ? "tw-border-l tw-border-primary-grey-100/80"
    : "";

  stickyClass += ` tw-px-${props.px}`;

  return stickyClass;
};

const tableBodyCellClass = (key: string): string => {
  const header = props.headers.find((header) => header.key === key);

  const stickyClass = header?.sticky
    ? "tw-sticky tw-right-0 tw-bg-[inherit]"
    : "";

  return stickyClass;
};

const tableBodyCellContentClass = (key: string): string => {
  const header = props.headers.find((header) => header.key === key);

  let stickyClass = header?.sticky
    ? "tw-border-l tw-border-primary-grey-100/80"
    : "";

  stickyClass += ` tw-px-${props.px}`;

  return stickyClass;
};

const onSelectAll = (event: Event): void => {
  const isChecked = (event.target as HTMLInputElement).checked;

  selectedItems.value = isChecked
    ? [...itemsToDisplay.value.filter((item) => !item.metadata?.inherited)]
    : [];
};

const onSingleSelect = () => {
  if (!props.withSelectAll) {
    // prevent the user from multi-selecting
    selectedItems.value = selectedItems.value.slice(-1);
  }
  if (!selectAll.value) {
    return;
  }
  selectAll.value = false;
};

const goNext = (): void => {
  resetSelection();

  currentPage.value = currentPage.value + 1;

  emit("changePage", currentPage.value);
};

const goPrev = (): void => {
  resetSelection();

  currentPage.value = currentPage.value - 1;

  emit("changePage", currentPage.value);
};

const changeItemsOnPage = () => {
  currentPage.value = STARTING_PAGE;

  emit("changeItemsOnPage", maxItemsOnPage.value);
};

const resetSelection = (): void => {
  selectAll.value = false;
  selectedItems.value = [];
};

const skeletonArray = computed(() => {
  const arr: Record<string | number, string>[] = [];

  for (let index = 0; index < 10; index++) {
    const element: Record<string | number, string> = {};
    props.headers.forEach((el: { key: string }) => {
      element[el.key] = "";
    });

    arr.push(element);
  }

  return arr;
});

const handleSort = (header: DataTableHeader) => {
  if (!header.sortable) {
    return;
  }

  if (sortBy.value !== header.key) {
    sortBy.value = header.key;
  }

  if (sortDesc.value === "asc") {
    sortDesc.value = "desc";
  } else {
    sortDesc.value = "asc";
  }

  emit("sortItems", sortBy.value, sortDesc.value);
};

const emitDeleteItems = (): void => {
  emit("onDeleteItems", selectedItems.value);

  resetSelection();
};

const emitReleaseItems = (): void => {
  emit("onReleaseItems", selectedItems.value);

  resetSelection();
};

const emitAllowItems = (): void => {
  emit("onAllowItems", selectedItems.value);

  resetSelection();
};

const emitSearch = (event: Event): void => {
  currentPage.value = STARTING_PAGE;

  emit("search", (event.target as HTMLInputElement).value.trim());
};

const toggleSetColumnTooltip = (): void => {
  isColumnSetTooltipOpen.value = !isColumnSetTooltipOpen.value;
};

onClickOutside(columnSetTooltip, () => {
  isColumnSetTooltipOpen.value = false;
});

const isRowClicked = ref<null | string | number>(null);

const rowClick = (value: DataTableItem) => {
  isRowClicked.value = value.id;
  emit("onRowClick", value);
};

watch(
  () => props.headers,
  () => {
    tableHeaderCells.value = props.headers.map((header) => {
      const cell = { ...header };
      const isEnabledInObject = "enabled" in cell;

      if (!isEnabledInObject) {
        cell.enabled = true;
      }

      return cell;
    });

    tableCellsToDisplay.value = tableHeaderCells.value
      .filter((cell) => cell.enabled)
      .map((cell) => cell.key);
  },
  { deep: true },
);

watch(
  () => tableCellsToDisplay.value,
  () => {
    tableHeaderCells.value = tableHeaderCells.value.map((headerCell) => ({
      ...headerCell,
      enabled: tableCellsToDisplay.value.includes(headerCell.key),
    }));

    tableBodyCells.value = tableHeaderCells.value
      .filter((cell) => cell.enabled)
      .map((cell) => cell.key);

    emit("changeSelectedColumns", tableCellsToDisplay.value);
  },
);

watch(
  () => props.defaultItemsOnPage,
  () => {
    maxItemsOnPage.value = props.defaultItemsOnPage || props.itemsPerPage[0];
  },
);

watch(
  () => props.defaultSortBy,
  () => {
    sortBy.value = props.defaultSortBy;
  },
);

watch(
  () => props.defaultSortDesc,
  () => {
    sortDesc.value = props.defaultSortDesc;
  },
);

watch(
  () => props.items,
  () => {
    resetSelection();
  },
);

watch(
  () => selectedItems.value,
  () => {
    emit("onSelectItems", selectedItems.value);
  },
);

watch(
  () => props.total,
  () => (currentPage.value = STARTING_PAGE),
);
</script>

<style scoped></style>
